import { DashboardSkeleton } from "./skeletons";

/**
 * Generic loading fallback for Suspense boundaries
 */
export function LoadingFallback() {
  return (
    <div className="container py-6">
      <DashboardSkeleton />
    </div>
  );
}

/**
 * Minimal loading fallback with spinner
 */
export function MinimalLoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">ກຳລັງໂຫຼດ...</p>
      </div>
    </div>
  );
}

/**
 * Page loading fallback with message
 */
export function PageLoadingFallback({ message = "ກຳລັງໂຫຼດໜ້າ..." }: { message?: string }) {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-4">
        <div className="h-16 w-16 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <div className="text-center space-y-2">
          <p className="text-lg font-medium">{message}</p>
          <p className="text-sm text-muted-foreground">ກະລຸນາລໍຖ້າຊັ່ວຄາວ...</p>
        </div>
      </div>
    </div>
  );
}
